import { useMutation, useQueryClient } from '@tanstack/react-query';
import { onboardingService, type OnboardingProfileData, type OnboardingCompanyData } from '../services/onboarding.service';

interface CompleteOnboardingData {
  profile: OnboardingProfileData;
  company: OnboardingCompanyData;
}

export function useCompleteOnboarding() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: CompleteOnboardingData) => {
      // Update profile first
      await onboardingService.updateProfile(data.profile);

      // Then update company
      await onboardingService.updateCompany(data.company);

      // Mark onboarding as complete
      await onboardingService.completeOnboarding();

      return true;
    },
    onSuccess: () => {
      // Invalidate relevant queries
      queryClient.invalidateQueries({ queryKey: ['onboarding-status'] });
      queryClient.invalidateQueries({ queryKey: ['profile'] });
      queryClient.invalidateQueries({ queryKey: ['company'] });
    },
  });
}
